var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXmr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5441_6112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.246 35.5173C69.246 54.6388 53.7462 70.1408 34.6234 70.1408C15.5005 70.1408 0.000732422 54.6388 0.000732422 35.5173C0.000732422 16.3958 15.5009 0.893555 34.6234 0.893555C53.7458 0.893555 69.246 16.3943 69.246 35.5173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6255 0.893555C15.5095 0.893555 -0.017715 16.4177 0.00662036 35.5162C0.0114137 39.3372 0.62072 43.0128 1.7643 46.4509H12.1231V17.3246L34.6255 39.8269L57.1269 17.3246V46.4514H67.4879C68.6331 43.0135 69.2393 39.3379 69.2461 35.5167C69.2788 16.3983 53.7436 0.898164 34.6255 0.898164V0.893555Z",
    fill: "#4B5158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4491 44.9994L19.6289 35.1787V53.5063H12.1209L5.03613 53.5076C11.1132 63.4775 22.0958 70.1468 34.6241 70.1468C47.1524 70.1468 58.1356 63.4761 64.2137 53.5061H49.6171V35.1787L39.7963 44.9994L34.623 50.1726L29.4495 44.9994H29.4491Z",
    fill: "#4B5158"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5441_6112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.2469,
    height: 69.2543,
    fill: "white",
    transform: "translate(0 0.893555)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmr);
export default __webpack_public_path__ + "static/media/xmr.16dfd68244700ac74b5ce68fca9379f9.svg";
export { ForwardRef as ReactComponent };